import React from 'react';

const SimpleSteps = () => {
  const steps = [
    {
      number: '1',
      title: 'Registrer bilen',
      description: 'Skriv inn registreringsnummer og kilometerstand. Tar 30 sekunder.'
    },
    {
      number: '2',
      title: 'Vi inspiserer bilen',
      description: 'Book en tid som passer deg. Vi kommer til deg eller du leverer selv.'
    },
    {
      number: '3',
      title: 'Motta bud',
      description: 'Forhandlere gir bud. Du velger det beste eller takker nei.'
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl font-bold text-gray-900 mb-4">
            Så enkelt er det
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-12">
          {steps.map((step, index) => (
            <div key={index} className="relative">
              <div className="flex flex-col items-center text-center">
                <div className="w-16 h-16 bg-gray-900 text-white rounded-full flex items-center justify-center text-2xl font-bold mb-4">
                  {step.number}
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">{step.title}</h3>
                <p className="text-gray-600">{step.description}</p>
              </div>
              {index < steps.length - 1 && (
                <div className="hidden md:block absolute top-8 left-full w-full h-0.5 bg-gray-300 -z-10"></div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default SimpleSteps;